/* =========================================================================
   KENZA MEGA MENU v7 — JS
   - Hover open (80ms delay)
   - Hover close (200ms delay)
   - Click outside / Escape closes
   - Calculates mega panel top position based on header location
   ========================================================================= */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.kenza-nav').forEach(initNav);
    updateMegaTop();
  }

  function updateMegaTop() {
    // Find the header bottom position and set CSS var for mega panel top
    const header = document.querySelector('.site-header, .f-section-header, header');
    if (!header) return;
    const rect = header.getBoundingClientRect();
    const top = rect.bottom + 4;
    document.querySelectorAll('.kenza-mega').forEach((m) => {
      m.style.setProperty('--kn-mega-top', top + 'px');
    });
  }

  function initNav(nav) {
    const items = nav.querySelectorAll('.kenza-nav__item--has-mega, .kenza-nav__item--has-dropdown');
    if (!items.length) return;

    let openTimer = null;
    let closeTimer = null;

    function closeAll() {
      items.forEach((it) => {
        it.classList.remove('is-open');
        const link = it.querySelector('.kenza-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach((item) => {
      const link = item.querySelector('.kenza-nav__link');

      function open() {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => {
          items.forEach((other) => {
            if (other !== item) other.classList.remove('is-open');
          });
          item.classList.add('is-open');
          if (link) link.setAttribute('aria-expanded', 'true');
          updateMegaTop();
        }, 80);
      }

      function close() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 200);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);

      if (link) {
        link.addEventListener('focus', open);
      }
    });

    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  // Re-calc mega top on scroll and resize
  window.addEventListener('scroll', updateMegaTop, { passive: true });
  window.addEventListener('resize', updateMegaTop);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.kenza-nav')) init();
  });
})();